import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PlatformEnum } from '@panamax/app-state';
import { SubCategory } from '@usf/inventory-types';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-past-purchases',
  templateUrl: './past-purchases.component.html',
  styleUrls: ['./past-purchases.component.scss'],
})
export class PastPurchasesComponent {
  readonly PlatformEnum = PlatformEnum;

  @Input() platform: PlatformEnum;
  @Input() selectedCreateInventoryOption: SubCategory;
  @Input() validTimes: Observable<boolean[]>;
  @Output() selectPastPurchaseEmitter: EventEmitter<any> = new EventEmitter();

  pastPurchaseDays: Number;

  constructor() {}

  onPastPurchaseDaysChange() {
    this.selectPastPurchaseEmitter.emit(this.pastPurchaseDays);
  }
}
